import { IExpenseClaim } from 'Interfaces/expenseClaim';
import { requiredFieldMessage } from 'Regex';
import * as yup from 'yup';

export const ExpenseClaimDetailsSchema = yup.object().shape({
  travelDate: yup
    .date()
    .typeError('')
    .required(requiredFieldMessage)
    .nullable()
    .default(undefined),
  isPublicTransport: yup
    .boolean()
    .required(requiredFieldMessage)
    .default(false),
  publicTransportPrice: yup
    .string()
    .when('isPublicTransport', {
      is: (isPublicTransport: boolean) => isPublicTransport,
      then: () => yup.string().required(requiredFieldMessage),
      otherwise: () => yup.string(),
    })
    .default(''),
  originPlace: yup.string().required(requiredFieldMessage).default(''),
  destinationPlace: yup.string().required(requiredFieldMessage).default(''),
}) as yup.SchemaOf<IExpenseClaim>;
